import { Component, Inject, Optional } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { OverviewService } from 'src/app/services/overview.service';


export interface TicketElement {
  id: number;
  title: string;
  subtext: string;
  assignee: string;
  imgSrc: string;
  status: string;
  date: string;
}


export interface productsData {
  id: number;
  imagePath: string;
  uname: string;
  position: string;
  productName: string;
  budget: number;
  priority: string;
}

interface month {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-tickets',
  templateUrl: './tickets.component.html',
})
export class AppTicketsComponent {
  params ;
  
 ELEMENT_DATA ;
 dataSource;
 displayedColumns: string[] = [ 'code','message','createdAt','trend','action'];


  constructor(private dialog : MatDialog, private route : ActivatedRoute, private overviewService: OverviewService){
    
    this.route.params.subscribe(params => {
      console.log(params)
      this.params = params 
    })
  }
  async ngOnInit() {
   
    this.ELEMENT_DATA =  await this.overviewService.getActiveIssues(this.params.companyId,this.params.siteId,this.params.systemId)
    console.log(this.ELEMENT_DATA)
    this.dataSource = this.ELEMENT_DATA;

  }

  openDialog(action: string, obj: any): void {
    obj.action = action;
    const dialogRef = this.dialog.open(AppTicketDialogContentComponent, {
      data: obj,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.event === 'Add') {
        this.addRowData(result.data);
      } else if (result.event === 'Resolve') {
        this.updateRowData(result.data);
      } else if (result.event === 'Delete') {
        this.deleteRowData(result.data);
      }
    });
  }
  // tslint:disable-next-line - Disables all
  addRowData(row_obj: TicketElement): void {
    const d = new Date();
    this.dataSource.data.unshift({
      id: d.getTime(),
      title: row_obj.title,
      subtext: row_obj.subtext,
      assignee: row_obj.assignee,
      imgSrc: '/assets/images/profile/user-1.jpg',
      status: row_obj.status,
      date: row_obj.date,
    });
  }

  // tslint:disable-next-line - Disables all
  updateRowData(row_obj) {
    console.log(row_obj)
    this.overviewService.updateActiveIssueById(row_obj.uid,{active:false});
      
    this.overviewService.updateActiveTask(row_obj,row_obj.code)
  }

  // tslint:disable-next-line - Disables all
  deleteRowData(row_obj: TicketElement): boolean | any {
    this.dataSource.data = this.dataSource.data.filter((value, key) => {
      return value.id !== row_obj.id;
    });
  }

}

@Component({
  // tslint:disable-next-line - Disables all
  selector: 'app-dialog-content',
  templateUrl: 'ticket-dialog-content.html',
})
// tslint:disable-next-line - Disables all
export class AppTicketDialogContentComponent {
  action: string;
  // tslint:disable-next-line - Disables all
  local_data: any;

  constructor(
    public dialogRef: MatDialogRef<AppTicketDialogContentComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: TicketElement
  ) {
    this.local_data = { ...data };
    this.action = this.local_data.action;
  }

  doAction(): void {
    this.dialogRef.close({ event: this.action, data: this.local_data });
  }

  closeDialog(): void {
    this.dialogRef.close({ event: 'Cancel' });
  }
}